/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
export function lazyLoadInit() {
  if (typeof LazyLoad === "function") {
    adminConfig.lazyLoad = new LazyLoad({
      class_loaded: 'img-reveal'
    });
  }
}